import type { SVGProps } from 'react'
const SvgSyBatteryFull = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<rect width={10} height={15} x={7} y={6} fillOpacity={0.24} rx={1.5} />
		<rect width={8} height={13} x={8} y={7} rx={1} />
		<rect width={6} height={2} x={9} y={3} fillOpacity={0.24} rx={1} />
	</svg>
)
export default SvgSyBatteryFull
